export const MODULE_NAME = 'marketplaceUser';
export const REDUCER_NAMESPACE = 'MARKETPLACE_USER';
